import { useWeb3React } from "@web3-react/core";
import AddressDropdown from "../AddressDropdown/AddressDropdown";
import ConnectWalletButton from "../Common/ConnectWalletButton";
import React, { useCallback, useEffect, useState } from "react";
import { HeaderLink } from "./HeaderLink";
// import connectWalletImg from "img/ic_wallet_24.svg";
import connectWalletImg from "img/ic_wallet_25.svg";
import lanImg from "img/lan.svg";
import { Link } from "react-router-dom";

import "./Header.css";
import { isHomeSite, getAccountUrl } from "lib/legacy";
import { isDevelopment } from "lib/legacy";
import cx from "classnames";
import { Trans } from "@lingui/macro";
import NetworkDropdown from "../NetworkDropdown/NetworkDropdown";
import LanguagePopupHome from "../NetworkDropdown/LanguagePopupHome";
import { ARBITRUM, ARBITRUM_TESTNET, AVALANCHE, FTMTEST, getChainName, OPTEST } from "config/chains";
import { switchNetwork } from "lib/wallets";
import { useChainId } from "lib/chains";

type Props = {
  openSettings: () => void;
  small?: boolean;
  setWalletModalVisible: (visible: boolean) => void;
  disconnectAccountAndCloseSettings: () => void;
  redirectPopupTimestamp: number;
  showRedirectModal: (to: string) => void;
};

export function AppHeaderUser({
  openSettings,
  small,
  setWalletModalVisible,
  disconnectAccountAndCloseSettings,
  redirectPopupTimestamp,
  showRedirectModal,
}: Props) {
  const { chainId } = useChainId();
  const { active, account } = useWeb3React();
  const showConnectionOptions = !isHomeSite();
  const [showLan, setShowLan] = useState(null);
  function showLanTest() {
    console.log("Tesst");
  }
  const networkOptions: any[] = [
    /* {
      label: getChainName(ARBITRUM),
      value: ARBITRUM,
      icon: "ic_arbitrum_24.svg",
      color: "#264f79",
    },
    {
      label: getChainName(AVALANCHE),
      value: AVALANCHE,
      icon: "ic_avalanche_24.svg",
      color: "#E841424D",
    }, */
  ];
  if (isDevelopment()) {
    // networkOptions.push({
    //   label: getChainName(FTMTEST),
    //   value: FTMTEST,
    //   icon: "ic_fantom.svg",
    //   color: "#264f79",
    // });
    networkOptions.push({
      label: getChainName(OPTEST),
      value: OPTEST,
      icon: "ic_optimism.svg",
      color: "#264f79",
    });
  }
  useEffect(() => {
    if (active) {
      setWalletModalVisible(false);
    }
  }, [active, setWalletModalVisible]);

  const onNetworkSelect = useCallback(
    (option) => {
      if (option.value === chainId) {
        return;
      }
      return switchNetwork(option.value, active);
    },
    [chainId, active]
  );

  const selectorLabel = getChainName(chainId);

  if (!active) {
    return (
      <div className="App-header-user">
        <div className={cx("App-header-trade-link", { "homepage-header": isHomeSite() })}>
          {/* <HeaderLink
            className="default-btn-new"
            to="/trade"
            redirectPopupTimestamp={redirectPopupTimestamp}
            showRedirectModal={showRedirectModal}
          >
            <Trans>trade now</Trans>
          </HeaderLink> */}
          {showConnectionOptions ? (
            <Link to="/trade" className="default-btn-new">
              <Trans>trade now</Trans>
            </Link>
          ) : (
            <Link to="" className="default-btn-new">
              <Trans>trade now</Trans>
            </Link>
          )}
        </div>

        {/* {showConnectionOptions ? (
          <>
            <ConnectWalletButton onClick={() => setWalletModalVisible(true)} imgSrc={connectWalletImg}>
              {small ? <Trans>Connect</Trans> : <Trans>Connect Wallet</Trans>}
            </ConnectWalletButton>
            <NetworkDropdown
              small={small}
              networkOptions={networkOptions}
              selectorLabel={selectorLabel}
              onNetworkSelect={onNetworkSelect}
              openSettings={openSettings}
            />
          </>
        ) : (
          <LanguagePopupHome />
        )} */}
        <>
          <ConnectWalletButton onClick={() => setWalletModalVisible(true)} imgSrc={connectWalletImg}>
            {small ? <Trans>Connect</Trans> : <Trans>Connect Wallet</Trans>}
          </ConnectWalletButton>
          <NetworkDropdown
            small={small}
            networkOptions={networkOptions}
            selectorLabel={selectorLabel}
            onNetworkSelect={onNetworkSelect}
            openSettings={openSettings}
          />
        </>

        {/* <div className="lan" onClick={}>
          <img src={lanImg}/>
        </div> */}
      </div>
    );
  }

  const accountUrl = getAccountUrl(chainId, account);

  return (
    <div className="App-header-user">
      <div className="App-header-trade-link">
        {/* <HeaderLink
          className="default-btn-new"
          to="/trade"
          redirectPopupTimestamp={redirectPopupTimestamp}
          showRedirectModal={showRedirectModal}
        >
          <Trans>trade now</Trans>
        </HeaderLink> */}
        {showConnectionOptions ? (
          <Link to="/trade" className="default-btn-new">
            <Trans>trade now</Trans>
          </Link>
        ) : (
          <Link to="" className="default-btn-new">
            <Trans>trade now</Trans>
          </Link>
        )}
      </div>

      {/* {showConnectionOptions ? (
        <>
          <div className="App-header-user-address">
            <AddressDropdown
              account={account}
              accountUrl={accountUrl}
              disconnectAccountAndCloseSettings={disconnectAccountAndCloseSettings}
            />
          </div>
          <NetworkDropdown
            small={small}
            networkOptions={networkOptions}
            selectorLabel={selectorLabel}
            onNetworkSelect={onNetworkSelect}
            openSettings={openSettings}
          />
        </>
      ) : (
        <LanguagePopupHome />
      )} */}

      <>
        <div className="App-header-user-address">
          <AddressDropdown
            account={account}
            accountUrl={accountUrl}
            disconnectAccountAndCloseSettings={disconnectAccountAndCloseSettings}
          />
        </div>
        <NetworkDropdown
          small={small}
          networkOptions={networkOptions}
          selectorLabel={selectorLabel}
          onNetworkSelect={onNetworkSelect}
          openSettings={openSettings}
        />
      </>
    </div>
  );
}
